export default __webpack_public_path__ + "static/media/component-info-card.d19a4464.png";